import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const MaintenanceLogModal = ({ selectedEquipment, onClose }) => {
  const [formData, setFormData] = useState({
    maintenanceType: 'routine',
    description: '',
    technician: '',
    cost: '',
    nextMaintenanceDate: ''
  });

  const maintenanceTypeOptions = [
    { value: 'routine', label: 'Routine Maintenance' },
    { value: 'repair', label: 'Repair' },
    { value: 'inspection', label: 'Inspection' },
    { value: 'cleaning', label: 'Deep Cleaning' },
    { value: 'calibration', label: 'Calibration' },
    { value: 'replacement', label: 'Part Replacement' }
  ];

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    // Handle maintenance log submission
    console.log('Maintenance log:', { ...formData, equipmentIds: selectedEquipment });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
      <div className="bg-card rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto custom-scrollbar" onClick={(e) => e?.stopPropagation()}>
        {/* Header */}
        <div className="sticky top-0 bg-card border-b border-border p-6 flex items-center justify-between">
          <div>
            <h2 className="text-2xl font-bold text-foreground">Log Maintenance</h2>
            <p className="text-sm text-muted-foreground mt-1">
              {selectedEquipment?.length} equipment item{selectedEquipment?.length > 1 ? 's' : ''} selected
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors"
          >
            <Icon name="X" size={24} className="text-muted-foreground" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Maintenance Type */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Maintenance Type *
            </label>
            <Select
              placeholder="Select maintenance type"
              options={maintenanceTypeOptions}
              value={formData?.maintenanceType}
              onChange={(value) => handleChange('maintenanceType', value)}
            />
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Description *
            </label>
            <textarea
              className="w-full px-4 py-3 bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary text-foreground placeholder:text-muted-foreground resize-none"
              rows={4}
              placeholder="Describe the maintenance work performed..."
              value={formData?.description}
              onChange={(e) => handleChange('description', e?.target?.value)}
              required
            />
          </div>

          {/* Technician */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Technician Name *
            </label>
            <Input
              type="text"
              placeholder="Enter technician name"
              value={formData?.technician}
              onChange={(e) => handleChange('technician', e?.target?.value)}
              required
            />
          </div>

          {/* Cost */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Cost (Optional)
            </label>
            <Input
              type="number"
              placeholder="Enter maintenance cost"
              value={formData?.cost}
              onChange={(e) => handleChange('cost', e?.target?.value)}
              step="0.01"
            />
          </div>

          {/* Next Maintenance Date */}
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">
              Next Maintenance Date *
            </label>
            <Input
              type="date"
              value={formData?.nextMaintenanceDate}
              onChange={(e) => handleChange('nextMaintenanceDate', e?.target?.value)}
              required
            />
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-3 pt-4 border-t border-border">
            <Button type="submit" variant="primary" iconName="Save" iconPosition="left">
              Save Maintenance Log
            </Button>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MaintenanceLogModal;